import { normalizePostProcessingPasses } from "./render.pass.utils";

export const getRenderPassAssetUrls = (renderSettings: any) => {
  const postProcessing = normalizePostProcessingPasses(renderSettings?.postProcessing);

  return postProcessing
    .filter((pass: any) => pass?.type === "lut" && pass?.cubeMapUrl)
    .map((pass: any, index: number) => ({
      url: pass.cubeMapUrl,
      kind: "lut" as const,
      label: `lut-pass-${index}`,
    }));
};
